module.exports = "/_next/static/images/requirements-7af3bdd58420280f5dccc82f6bb858c8.svg";